export default "__VITE_ASSET__Imb2IOsZ__"